import React, { useState } from 'react';
import { formatDate } from '../App';

const Hero = ({ onRegister, bgImage, title, year, user, onDashboard, dates, venue, lastDateEntry, lastDateWithdrawal, description, registrationEnabled }) => {
  const [showRules, setShowRules] = useState(false);

  const handleRegisterClick = () => {
    if (registrationEnabled) {
      onRegister();
    }
  };

  const handleAgreeAndRegister = () => {
    setShowRules(false);
    if (registrationEnabled) {
      onRegister();
    }
  };

  return (
    <section className="hero">
      <div className="container">
        <div className="hero-grid">
          <div className="hero-text-section">
            {/* Desktop Title */}
            <div className="hero-title-container desktop-only">
              <div className="hero-title-box-desktop">
                <div className="title-left-border"></div>
                <h1 className="hero-title-main" style={{ whiteSpace: 'pre-line' }}>
                  {title || "1ST OPEN BARODA MAJOR RANKING\nTABLE TENNIS TOURNAMENT"}
                </h1>
                <div className="hero-year-badge-desktop">{year || "2026"}</div>
              </div>
            </div>

            {/* Mobile Title */}
            <div className="hero-title-container-mobile mobile-only">
              <div className="hero-title-box-premium">
                <h1 className="hero-title-multiline" style={{ whiteSpace: 'pre-line' }}>
                  {title || "1ST OPEN BARODA MAJOR RANKING\nTABLE TENNIS TOURNAMENT"}
                </h1>
                <div className="hero-year-badge-block">{year || "2026"}</div>
              </div>
            </div>
            
            {description && (
              <p className="hero-description animate-fade-in" style={{ marginBottom: '2rem' }}>
                {description}
              </p>
            )}

            <div className="hero-actions">
              {(dates || venue || lastDateEntry || lastDateWithdrawal) && (
                <div className="hero-tournament-info animate-fade-in">
                  {dates && (
                    <div className="info-item">
                      <label>DATE :</label>
                      <span>{dates}</span>
                    </div>
                  )}
                  {venue && (
                    <div className="info-item">
                      <label>VENUE :</label>
                      <span>{venue}</span>
                    </div>
                  )}
                  <div className="info-item-small-grid">
                    {lastDateEntry && (
                      <div className="info-item">
                        <label>Last date to accept entry :</label>
                        <span>{formatDate(lastDateEntry)}</span>
                      </div>
                    )}
                    {lastDateWithdrawal && (
                      <div className="info-item">
                        <label>Last date to withdraw entry :</label>
                        <span>{formatDate(lastDateWithdrawal)}</span>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {user ? (
                <button className="btn-hero-register" onClick={onDashboard}>
                  Go to Dashboard
                </button>
              ) : (
                <>
                  <button className="btn-hero-rules" onClick={() => setShowRules(true)}>
                    Read Rules Before Registration
                  </button>
                  {registrationEnabled === true && (
                    <button className="btn-hero-register" onClick={handleRegisterClick}>
                      Register for Tournament
                    </button>
                  )}
                  {registrationEnabled === false && (
                    <button className="btn-hero-register" style={{ opacity: 0.7, cursor: 'not-allowed', background: '#333', color: '#888' }} disabled>
                      REGISTRATION CLOSED
                    </button>
                  )}
                </>
              )}
            </div>
          </div>
          
          {bgImage && (
            <div className="hero-image-box animate-float">
              <div className="hero-image-wrapper">
                <img src={bgImage} alt="Tournament Banner" />
                <div className="image-overlay-glow"></div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Rules Modal Overlay */}
      {showRules && (
        <div className="modal-overlay animate-fade-in">
          <div className="modal-card rules-modal">
            <div className="modal-header">
              <h2>Tournament <span>Rules & Regulations</span></h2>
              <button className="close-modal" onClick={() => setShowRules(false)}>&times;</button>
            </div>
            <div className="modal-body">
              <div className="rules-content-mini">
                <div className="rule-item-mini">
                  <span className="rule-num">01</span>
                  <p>This tournament is open to all amateur players.</p>
                </div>
                <div className="rule-item-mini">
                  <span className="rule-num">02</span>
                  <p>Only registered players of TTAB for the year 2026 can participate.</p>
                </div>
                <div className="rule-item-mini">
                  <span className="rule-num">03</span>
                  <p>Entry fees are <strong>non-refundable</strong>. Application must be on prescribed form.</p>
                </div>
                <div className="rule-item-mini">
                  <span className="rule-num">04</span>
                  <p>Proper uniforms and sports shoes are mandatory. (Synthetic flooring protection).</p>
                </div>
                <div className="rule-item-mini">
                  <span className="rule-num">05</span>
                  <p>Committee reserves the right to refuse any entry without reason.</p>
                </div>
                <div className="rule-item-mini">
                  <span className="rule-num">06</span>
                  <p>Original Birth Certificates are mandatory for age-restricted categories.</p>
                </div>
                <div className="rule-item-mini">
                  <span className="rule-num">07</span>
                  <p>Tournament commences 26th June 2026 (Hopes/Cadet/Sub-Jr at 14:30, Men at 19:00).</p>
                </div>
                <div className="rule-item-mini">
                  <span className="rule-num">08</span>
                  <p>GSTTA & TTFI rules apply. Committee decision is <strong>final and binding</strong>.</p>
                </div>
                <div className="rule-item-mini">
                  <span className="rule-num">09</span>
                  <p>Only TTFI-approved balls will be used.</p>
                </div>
                <div className="rule-item-mini">
                  <span className="rule-num">10</span>
                  <p>Committee reserves the right to cancel events or change draws/timings.</p>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn-cancel" onClick={() => setShowRules(false)}>Cancel</button>
              <button className="btn-agree" onClick={handleAgreeAndRegister}>I Agree & Register</button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Hero;